module.exports = __webpack_public_path__ + "static/pbt-icon-gray-b7f8a29a242977fcdc30b77a3ed93e64.jpg";